<template>
  <div>
  <!-- TODO： indexの構造確認が必要（カレンダー返さないよね？） -->
  <!-- カレンダーの存在チェック -->
  <div
  class="block item-hotel p-8 mb-2.5 sm:p-4"
  :class="{ horizonal: type === 'horizonal' }"
  >
  <!-- v-if="hasVacancyCalendars" -->
    <div class="item-content" :class="{ 'item-content-rakuten': extSystemCd(plan) === 'RakutenT' }">
      <div class="hotel-cover">
        <!-- TODO: 画像のパスがあっているか確認必要 -->
        <img :src="roomThumbnail" alt="demo"  class="plan-image"/>
        <!-- 画像がある場合はimg、ない場合は空div -->
        <template v-if="planRoomImage">
          <img :src="planRoomImage" alt="プラン部屋画像" class="plan-image" />
        </template>
        <template v-else>
          <div class="plan-image"></div>
        </template>
      </div>
      <div class="suggest-item-wrapper">

        <!-- 使用していない可能性あり 24/12/20 守重記載 start -->
        <div v-if="type === 'horizonal'" class="room-actions sm:hidden">
          <div class="flex items-end">
            <a-space>
              <button class="c-btn btn-white btn-sm btn-cms" @click="gotoDetails">
                お部屋の詳細
              </button>
              <button class="c-btn btn-white btn-sm btn-cms" @click="gotoDetails">
                空室カレンダー
              </button>
            </a-space>
          </div>
        </div>
        <!-- 使用していない可能性あり 24/12/20 守重記載 end -->
        <div v-else class="menu-item__tagWrap">
          <ul class="menu-item__tagList" v-if="getPlanIcons">
            <li v-for="(item, index) in getPlanIcons" :key="`tagsText-${index}`">
              <Tag 
                :text="item.iconNm"
                :class="[ 
                  item.iconNm === 'カフェ' || item.iconNm === '補助クーポン' ? 'plan-icon cafe-icon' : 'plan-icon',
                  item.iconNm === 'ベネポ貯まる' || item.iconNm === 'ベネポ使える' ? 'plan-icon bene-icon' : 'plan-icon',
                  item.iconNm === 'オンラインカード決済可' || item.iconNm === 'オンラインカード決済' ? 'plan-icon online-payment-icon' : 'plan-icon',
                ]"
                class="mb-2.5 sm:mb-2"
              />
            </li>
          </ul>
          <template v-for="(zaiko, index) in pZaikoList">
            <div
              class="menu-item__stockIcon"
              :key="`vacancy-${index}`"
              v-if="zaiko.planId === plan.planId && zaiko.roomId === plan.roomId">
              <Tag
                v-html="zaiko.stock"
                class="plan-icon plan-icon__vacancy mb-2.5 sm:mb-2"
              />
            </div>
          </template>
        </div>

        <div class="mb-2">
          <div class="content-title">
            <p class="label label-primary" v-show="isNewPlan(plan)">NEW</p>
            <h2>
              <a class="text-black text-epip plan-title" @click="gotoDetails">
                <!-- プラン名 -->
                {{ plan.title }}
              </a>
            </h2>
          </div>
        </div>

        <div class="menu-item__recommendedWrap">
          <div class="recommended-left flex items-center">
            <img
              src="~@/assets/images/recomment-rakuten.png"
              alt="demo"
              v-show="extSystemCd(plan) == 'RakutenT'"
              class="mr-3 sm:hidden img-recommended"
            />
            <img
              src="~@/assets/images/recommended-rakuten-mobile-icon.png"
              alt="demo"
              v-show="extSystemCd(plan) == 'RakutenT'"
              class="mr-3 hidden sm:flex img-recommended"
            />
            <img
              src="@/assets/images/bene-log.png"
              alt="demo"
              v-show="extSystemCd(plan) != 'RakutenT'"
              class="mr-3 img-recommended"
            />
          </div>
          <div class="services-offer">
            <div class="item flex items-center text-xs">
              <img
                src="~@/assets/images/breakfast-dinner-icon.svg"
                alt="person icon"
                class="flex mr-2 w-4 h-4"
              />
              <!-- 朝食・夕食ありなしテキスト -->
              <span class="font-bold">{{ getServiceText(plan) }}</span>
            </div>
          </div>

          <!-- チェックイン・アウト表示 -->
          <div class="plan-in-out">
            <p>
              <span class="inout-label">IN</span> {{ plan.ltPlanIn || '' }} 〜 {{ plan.ltPlanInLimit || '' }}
              <span class="inout-label">OUT</span> {{ plan.ltPlanOut || '' }}
            </p>
            <div class="pt-1" v-if="extSystemCd(plan) === 'RakutenT'">
              <div class="text-red-500">
                プランにより記載の時間と異なる場合があります。
              </div>
            </div>
          </div>

          <div class="plan-type" v-if="plan.na">
            <p class="plan-type__text">{{ plan.na }}</p>
          </div>

          <div class="services-hotelMeta">
            <ul class="services-hotelMeta__list">
              <li class="services-hotelMeta__item">
                <img
                  src="~@/assets/images/person-icon.svg"
                  alt="person icon"
                  class="flex mr-2 w-5 h-5"
                />
                <span>定員 {{ plan.maxSu }}名</span>
              </li>
              <li class="services-hotelMeta__item">
                <img
                  style="height: 13.96px"
                  src="~@/assets/images/bed-icon.svg"
                  alt="person icon"
                  class="flex mr-2 w-4"
                />
                <!-- 部屋タイプ -->
                <span>{{ plan.roomCondNm }}</span>
              </li>
              <li class="services-hotelMeta__item" v-if="extSystemCd(plan) != 'RakutenT' && plan.roomSizeTxt != null">
                <img
                  src="~@/assets/images/room-size-icon.svg"
                  alt="person icon"
                  class="flex mr-2 w-4 h-4"
                />
                <span>部屋のサイズ {{ plan.roomSizeTxt }}</span>
              </li>
              <li class="services-hotelMeta__item" v-if="plan.smokingDiv == '1'">
                <img
                  src="~@/assets/images/no-smoking-icon.svg"
                  alt="person icon"
                  class="flex mr-2 w-4 h-4"
                />
                <span>禁煙</span>
              </li>
              <li class="services-hotelMeta__item" v-if="plan.smokingDiv == '2'">
                <img
                  src="~@/assets/images/no-smoking-icon.svg"
                  alt="person icon"
                  class="flex mr-2 w-4 h-4"
                />
                <span>喫煙</span>
              </li>
              <li class="services-hotelMeta__item" v-if="plan.smokingDiv == '3'">
                <img
                  src="~@/assets/images/no-smoking-icon.svg"
                  alt="person icon"
                  class="flex mr-2 w-4 h-4"
                />
                <span>おまかせ</span>
              </li>
            </ul>
          </div>
        </div>

        <div class="menu-item__numberWrap">
          <p class="menu-item__numberWrap--inside" v-bind:class="{ hide: this.isHide }">
            <!-- 人単位か部屋単位を見極めるフラグが必要 -->
            <!-- <span v-if="getSymbolPlan">{{ getSymbolPlan }}</span> -->
            {{ plan.dateAvailables[0].kinKubun === '1' ? '1泊の料金' : '大人' + getConditions().adultHeadCnt + '人' + (getConditions().childCnt > 0 ? '/子ども' + getConditions().childCnt + '人/' : '/') + getConditions().stayNights + '泊' }}
          </p>
        </div>

        <div class="menu-item__priceTotalWrap">
          <!-- プランの最安値 -->
          <p class="menu-item__price" v-bind:class="{ hide: this.isHide }">
            合計<span class="menu-item__price--amount">{{ plan.minPrice | separatedByCommas }}</span>円{{ $route.query.checkInDate ? '' : '～' }}
          </p>
          <p v-if="!getConditions().childCnt" class="menu-item__perPerson">
            {{ plan.dateAvailables[0].kinKubun === '1' ? '1泊の料金' : '大人1名あたり' }}{{ Math.round(plan.minPrice / (getConditions().adultHeadCnt * getConditions().roomCnt)) | separatedByCommas }}{{ '円' }}{{ $route.query.checkInDate ? '' : '～' }}
          </p>
        </div>

        <div class="menu-item__bottomWrap">
          <div class="menu-item__granted" v-bind:class="{ hide: this.isHide }">
            <p class="menu-item__point" v-if="plan.planIcons.filter(data => data.iconCd === 'benepo_tamaru').length == 1">
              {{ '獲得ベネポ：' }}
              <span class="menu-item__point--point">
                <strong class="menu-item__point--number">{{ plan.benepoGrant | separatedByCommas }}</strong>p{{ $route.query.checkInDate ? '' : '～' }}
              </span>
              <span class="menu-item__point--rakuten" v-if="extSystemCd(plan) === 'RakutenT'">＋楽天ポイント
                <span class="menu-item__point--point">
                  <strong class="menu-item__point--number">1</strong>%〜
                </span>
              </span>
            </p>
          </div>
          <button class="menu-item__planDetail" @click="gotoDetails">
            詳細を見る
            <Icon name="arrow_next" class="menu-item__planDetail--icon ml-5 inline-block sm:hidden" stroke="#1f2021" width="7.31" height="13.121"/>
            <Icon name="arrow_next_small" class="menu-item__planDetail--icon hidden sm:ml-1 sm:inline-block hidden" stroke="#1f2021" width="5.811" height="10.121" />
          </button>
        </div>
      </div>
    </div>
    <InstructionLogin
      :description1="description1"
      :description2="description2"
      :visible="popupLogin"
      @ok="popupLogin = false"
      @cancel="popupLogin = false"
    />

  </div>
  </div>
</template>

<script>
import { get, isEmpty, minBy, cloneDeep } from 'lodash'
import moment from 'moment'
import func_utils from '@/mixins/func_utils'
const PLACEHOLDER_IMG = require('@/assets/images/slide-img-placeholder.png')
import { SCROLL_CALENDAR } from '@/store/modules/plan/actions'

export default {
  mixins: [func_utils],
  props: ['type', 'plan', 'hidePriceProps', 'numPeople', 'checkInDay', 'stayNights','pZaikoList', 'filterForm'],
  setup() {
    return {}
  },
  data() {
    return {
      roomBasicInfo: {},
      isHide: this.hidePriceProps || false,
      stayDay: moment(new Date()),
      visible: false,
      popupLogin: false,
      description1: 'ログインして',
      description2: 'サービスをご利用ください。'
    }
  },
  filters: {
    separatedByCommas(value) {
      return Number(value).toLocaleString()
    }
  },
  mounted() {
    // indexの値をそのまま使用するため不要
    // if (this.plan) {
    //   this.roomBasicInfo = this.plan.roomBasicInfo || {}
    // }

    // 料金、部屋タイプの特定に使うので不要（indexの値を使うため）
    // if (this.checkInDay) {
    //   this.stayDay = this.checkInDay
    // } else {
    //   this.stayDay = moment(this.stayDay).format('YYYY/MM/DD')
    // }

    this.$nextTick(() => {
      this.visible = true
    })
  },
  watch: {
    visible() {
      if (this.visible === false) {
        this.visible = true
      }
    }
  },
  computed: {
    // 指定日時の料金を取得するために使用しているため、indexから値をとる場合には不要
    // currentDay() {
    //   return moment(this.checkInDay).format('YYYY/MM/DD')
    // },

    roomThumbnail() {
      const imageUrl = get(this.plan, 'wImgUrl', null)
      if (imageUrl) {
        return imageUrl
      }
      return PLACEHOLDER_IMG
    },
    planRoomImage() {
      const roomImageUrl = get(this.plan, 'roomImgUrl1', null)
      if (roomImageUrl) {
        return roomImageUrl
      }
      return ''
    },
    totalPeopleCnt() {
      // URLクエリより大人と子どもの人数を取得
      const query = this.$route.query
      const adultHeadCnt = Number(query.adultHeadCnt) || 0
      const exUpperGradesHeadCnt = Number(query.exUpperGradesHeadCnt) || 0
      const exLowerGradesHeadCnt = Number(query.exLowerGradesHeadCnt) || 0
      const youjiAHeadCnt = Number(query.youjiAHeadCnt) || 0
      const youjiBHeadCnt = Number(query.youjiBHeadCnt) || 0
      const youjiCHeadCnt = Number(query.youjiCHeadCnt) || 0
      const youjiDHeadCnt = Number(query.youjiDHeadCnt) || 0

      // 大人＋子どもの総人数を算出
      const totalPeopleCnt = [
        adultHeadCnt,
        exUpperGradesHeadCnt,
        exLowerGradesHeadCnt,
        youjiAHeadCnt,
        youjiBHeadCnt,
        youjiCHeadCnt,
        youjiDHeadCnt,
      ].reduce((a, b) => a + b)

      return totalPeopleCnt
    },

    // カレンダーの存在確認　（カレンダー使わない・・・？）
    // hasVacancyCalendars() {
    //   return !isEmpty(get(this.plan, 'vacancyCalendar.vacancyCalendars'))
    // },

    // indexの最安値を使用するため不要
    // getPricePlan() {
    //   const listVacancy = get(this.plan, 'vacancyCalendar.vacancyCalendars')
    //   if (isEmpty(listVacancy)) return ''
    //   else {
    //     let currentCalendar
    //     if (!this.$route.query.checkInDate) {
    //       // 日付未指定の場合
    //       currentCalendar = listVacancy
    //     } else {
    //       currentCalendar = listVacancy?.find(
    //         (calendar) => calendar.stayDay === this.currentDay
    //       )
    //     }
    //     if (!isEmpty(currentCalendar)) {
    //       let curentPrice = currentCalendar?.roomPrice ?? currentCalendar?.price
    //       return this.formatCurrency(curentPrice || 0)
    //     } else {
    //       const min = minBy(listVacancy, 'price')
    //       return this.formatCurrency(min?.price || 0)
    //     }
    //   }
    // },

    // 人単位か部屋単位のテキスト、直接templateに記載するため不要の想定
    // getSymbolPlan() {
    //   let calendar
    //   if (!this.$route.query.checkInDate) {
    //     // 日付未指定の場合
    //     calendar = get(this.plan, 'vacancyCalendar.vacancyCalendars', [])
    //   } else {
    //     calendar = get(this.plan, 'vacancyCalendar.vacancyCalendars', []).find(
    //       (calendar) => calendar.stayDay === this.currentDay
    //     ) || {}
    //   }
    //   // eslint-disable-next-line eqeqeq
    //   return calendar?.roomPrice != null ? '1泊の料金' : '大人1人'
    // },

    // 使用していないため不要
    // getStockPlan() {
    //   let calendar
    //   if (!this.$route.query.checkInDate) {
    //     // 日付未指定の場合
    //     calendar = get(this.plan, 'vacancyCalendar.vacancyCalendars', [])
    //   } else {
    //     const currentDay = moment(this.stayDay).format('YYYY/MM/DD')
    //     calendar = get(this.plan, 'vacancyCalendar.vacancyCalendars', []).find(
    //       (calendar) => calendar.stayDay === currentDay
    //     )
    //   }
    //   const stock = get(calendar, 'stock', 0)
    //   return stock >= 1 && stock <= 4 ? 'tooltip-red' : 'tooltip-blue'
    // }
    getPlanIcons(){
      let result = this.plan?.planIcons ? cloneDeep(this.plan.planIcons) : [];
      return result;
    }
  },
  methods: {
    // 使用していないため不要
    // formatDate(plan) {
    //   const date = get(plan, 'planBasicInfo.planRcEndDt', null)
    //   if (moment(date).isValid()) {
    //     return moment(date).format('YYYY年MM月DD日まで')
    //   }
    //   return ''
    // },

    // TODO: indexの構造確認が必要
    isNewPlan(plan) {
      const planRcSttDt = get(plan, 'planRcSttDt', null)
      const today = moment()
      if (
        planRcSttDt &&
        moment(planRcSttDt).isValid() &&
        moment(planRcSttDt).isAfter(today.subtract(5, 'days'))
      ) {
        return true
      }
      return false
    },

    getServiceText(plan) {
      // redmine-81939 朝食・夕食ありなしテキスト未表示修正
      const dateAvailable = plan.dateAvailables?.[0]
      if (!dateAvailable) return ''
      const breakfastFlag = dateAvailable.bflg
      const dinnerFlag = dateAvailable.dflg
      if (breakfastFlag == '1' && dinnerFlag == '1') {
        return '朝食・夕食つき'
      } else if (breakfastFlag == '1') {
        return '朝食のみ'
      } else if (dinnerFlag == '1') {
        return 'ディナーのみ'
      }
      return '食事なし'
    },

    // TODO： ベネオリかベネ楽かどうかの判定フラグが必要
    extSystemCd(plan) {
      return get(plan, 'extImpSysCd', null)
    },

    // プラン詳細へ遷移
    gotoDetails(params) {
      const { menuNo } = this.$route.params
      const query = this.$route.query
      const planId = this.plan.planId
      const roomId = this.plan.roomId
      if (!this.$auth.loggedIn) {
        this.setCurrentHref(
          `${
            process.env.VUE_APP_BASE_URL
          }/menus/${menuNo}/plans/${planId}/rooms/${roomId}?${
            this.$route.fullPath.split('?')[1]
          }`
        )
        return (window.location = `${process.env.VUE_APP_API_URL}/v1/stay/login`)
      }
      this.$store.dispatch(SCROLL_CALENDAR, params)
      this.$router.push({
        path: `/menus/${menuNo}/plans/${planId}/rooms/${roomId}`,
        query
      })
    },

    getConditions() {
      const childData = [
        'exUpperGradesHeadCnt',
        'exLowerGradesHeadCnt',
        'youjiAHeadCnt',
        'youjiBHeadCnt',
        'youjiCHeadCnt',
        'youjiDHeadCnt'
      ]

      let childCnt = 0;
      childData.forEach((key) => {
        if (this.filterForm[key] > 0) {
          childCnt += parseInt(this.filterForm[key]);
        }
      })
      return {
        checkInDate: this.filterForm.checkInDate,
        stayNights: this.filterForm.checkInDate ? this.filterForm.stayNights : 1,
        adultHeadCnt: this.filterForm.adultHeadCnt,
        childCnt: childCnt,
        roomCnt: Number(this.filterForm.roomCnt) || Number(this.$route.query.roomCnt) || 1,
      };
    },
  },
}
</script>

<style lang="scss" scoped>
@import './styles.scss';

@mixin sp {
  @media screen and (max-width: 639px) {
    @content;
  }
};

// タグと料金周りの追加修正
.list-plan-item {
  &__zaiko-tags {
    justify-content: flex-end;
  }
  &__zaiko-tag {
    &.--sp {
      background-color: #edeef0;
      color: #e60021;
      flex-shrink: 0;
      font-size: 12px;
    }
  }
  &__status {
    margin-bottom: .5rem;
  }

  &__view-detail {
    &__tag {
      background-color: transparent !important;
      border: none;
      color: #e60021;
      font-weight: bold;
    }
  }

  &__pc-price {
    align-items: center;
    display: flex;
    padding: .5rem 0;
  }

  @include sp {
    &__tags-and-price {
      flex-wrap: wrap;

      &__tags,
      &__sp-price {
        width: 100%;
      }

      &__tags {
        margin-bottom: 1rem;
      }

      &__sp-price {
        margin-bottom: .5rem;

        &__inner {
          align-items: center;
          display: flex;

          .min-price {
            line-height: 1;
          }
        }
      }
    }
  }
}

::v-deep .ant-btn-lg {
  font-weight: 700;
  color: #1f2021;
}

::v-deep .btn-dark {
  background-color: #434547;
  color: #ffffff;
}
.img-recommended {
  object-fit: contain;
}

.a-tooltip-custom-zindex {
  z-index: 1000;
}

.tooltip-red .ant-tooltip-inner {
  background-color: #da291c;
  color: #ffffff;
}

.tooltip-blue .ant-tooltip-inner {
  background-color: #259bee;
  color: #ffffff;
}

.suggest-item {
  &-point {
    @apply text-2xl font-bold;
    line-height: 36px;
    color: #E60021;
    font-size: 0.9375rem;
    span {
      @apply font-normal;
      color: #000;
      font-size: 0.75rem;
    }
    @screen sm {
      @apply text-lg;
      line-height: 20px;
      font-size: 0.8125rem;
      span {
        font-size: 0.625rem;
      }
    }
  }
  &-wrapper {
    @apply p-4 rounded;
    background-color: #FFFAF0;
    margin-left: 1rem;
    width: calc(100% - (192px + 1rem));
    @screen md {
      width: 100%;
      margin-left: 0;
      border: 1px solid #FDEED4;
      border-radius: .5rem;
    }
    .content-title {
      display: flex;
      align-items: center;
      margin-bottom: .5rem;
      .label-primary {
        margin-right: .5rem;
      }
      .plan-title {
        @apply font-bold;
        font-size: 1rem;
        line-height: 22px;
        font-feature-settings: "palt";
        @screen sm {
          font-size: 0.875rem;
          line-height: 20px;
        }
      }
    }
    .plan-type {
      font-size: .875rem;
      font-weight: bold;
      width: 100%;
    }
    .plan-in-out {
      font-size: 12px;
      width: 100%;
      @screen sm {
        font-size: 10px;
      }
    }
  }
  
}

.plan-icon {
  @apply mr-2;
  padding: 2px 8px !important;
  letter-spacing: 0px;
  font-size: 10px;
  // 残りx部屋、空室なしのスタイル
  &__vacancy{
    background: #E60021 !important;
    color: #fff !important;
    padding: 2px 8px !important;
    margin-left: 0;
  }
}
.cafe-icon {
  color: #f4f5f6 !important;
  background-color: #0d76bf !important;
}
.bene-icon {
  color: #1F2021 !important;
  background-color: #FFD966 !important;
}
.online-payment-icon {
  color: #ffffff !important;
  background-color: #f58700 !important;
}

.menu-item {
  &__tagWrap {
    display: flex;
    flex-wrap: wrap;
  }
  &__tagList {
    display: flex;
    flex-wrap: wrap;
    .tag {
      font-size: 10px;
      margin: 0 .5rem .625rem 0;
      &.plan-icon {
        &:hover {
          opacity: 1;
        }
        &__vacancy {
          font-size: .75rem;
        }
      }
    }
  }
  &__stockIcon {
    margin-left: auto;
    .plan-icon {
      &__vacancy {
        font-size: 10px;
        margin-right: 0;
        &:hover {
          opacity: 1;
        }
      }
    }
  }
  &__recommendedWrap {
    display: flex;
    flex-wrap: wrap;
    gap: .5rem 0;
    margin-bottom: 1rem;
  }
  &__numberWrap {
    border-top: 1px solid #CACCCF;
    padding-top: 1rem;
    &--inside {
      display: flex;
      align-items: center;
      font-size: .75rem;
      margin-bottom: .5rem;
    }
  }
  &__priceTotalWrap {
    display: flex;
    align-items: center;
  }
  &__bottomWrap {
    display: flex;
  }
  &__perPerson {
    display: block;
    font-size: 12px;
    line-height: 1.5;
    color: #63666A;
    margin: 0 0 0 1rem;
  }
  &__price {
    font-size: .875rem;
    font-weight: bold;
    line-height: 1.25rem;
    color: #E60021;
    margin-bottom: .5rem;
    &--amount {
      font-size: 1.5rem;
    }
  }
  &__granted {
    font-size: .75rem;
  }
  &__point {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    font-size: .75rem;
    &--point {
      font-weight: bold;
      color: #E60021;
      margin-right: 4px;
    }
    &--number {
      font-size: 1rem;
    }
    &--percent {
      font-size: .625rem;
      background: #fff;
      border-radius: 4px;
      padding: 2px 5px;
    }
    &--rakuten {
      display: flex;
      align-items: center;
      margin-left: .5rem;
    }
  }
  &__planDetail {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    background: #fff;
    font-size: 0.875rem;
    line-height: 2.125rem;
    font-weight: bold;
    color: #1F2021;
    border: 1px solid #1F2021;
    text-align: center;
    margin: auto 0 0 auto;
    width: 11rem;
    height: 2.5rem;
    transition: .5s;
    &--icon {
      width: 6px;
    }
    &:hover {
      opacity: .8;
    }
  }
}

.services-offer {
  display: flex;
  align-items: center;
  margin-right: 1rem;
}

.services-hotelMeta {
  &__list {
    display: flex;
    align-items: center;
  }
  &__item {
    display: flex;
    align-items: center;
    margin-right: 1rem;
    font-size: .75rem;
  }
}

.inout-label {
  font-size: 10px;
  color: #1F2021;
  border: 1px solid #63666A;
  background: #FFFFFF;
  padding: 0 8px;
  border-radius: 4px;
  margin-right: 4px;
  margin-left: 8px;
  display: inline-block;

  &:first-child {
    margin-left: 0;
  }
}

@media (max-width: $contentWidthS) {
  .content {
    &__price {
      strong {
        font-size: 13px;
      }
    }

    &__meta {
      display: grid !important;
      grid-template-columns: repeat(2, 100px);
      column-gap: 17px;
    }
  }

  .menu-item {
    &__tagWrap {
      flex-wrap: nowrap;
    }
    &__tagList {
      .bene-icon {
        border-radius: .25rem;
      }
    }
    &__stockIcon {
      margin-left: auto;
      .plan-icon__vacancy {
        border-radius: .25rem;
        margin-right: 0;
      }
    }
    &__priceTotalWrap {
      display: block;
    }
    &__bottomWrap {
      flex-wrap: wrap;
    }
    &__perPerson {
      margin: 0 0 .5rem;
    }
    &__point {
      &--rakuten {
        width: 100%;
        margin-left: 0;
      }
    }
    &__planDetail {
      width: 5.625rem;
      height: 2rem;
      font-size: 0.75rem;
    }
  }

  .services-hotelMeta {
    &__list {
      flex-wrap: wrap;
      gap: .5rem 0;
    }
    &__item {
      &:last-child {
        margin-right: 0;
      }
    }
  }
}

</style>
